// extracted by mini-css-extract-plugin
module.exports = {"button":"virtual-assistant-buttons_button__5HDy7"};